module.exports = __webpack_public_path__ + "img/logo-white-167x57.277ba29.svg";